import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Card, Layout, Banner, Page, FormLayout, TextField, Spinner, DropZone, Thumbnail, Button, BlockStack, ChoiceList, Tooltip, Icon, Badge, Text, Modal, Popover, ActionList } from '@shopify/polaris';
import Switch from "react-switch";

import { LocalBusinessTypeAndSpecialType } from './constants';
import {
  reqCheckPreviewFinish,
  reqUpdateHTMLSitemap,
  reqUpdateStructuredData,
  reqGetHtmlSitemapData,
  reqInsertCreateCampaignImage,
  reqUpdateJsonLDConfig,
  reqUpdateHideNotify,
  reqUpdateCustomerClick,
  reqSaveSwitchState,

} from '../../../../api';
import AddLinks from '../../../../../src/components/AddLinks/index';
import SkeltonLoading from '../../../../components/SkeltonLoading';
import { connect } from 'react-redux'
import { setSaveSwitchData } from '../../../../redux/actions/getAppPublicData';
import { setPageLoading } from '../../../../redux/actions/getAppPageData';
import { setPageData } from '../../../../redux/actions/getAppPageData';
import { cloneDeep } from 'lodash';
import SwitchAll from '../../../../utils/switchState';
import './index.css';
import {
  // QuestionMarkInverseMajor,
  DiamondAlertMinor,
  CirclePlusMajor,
  MobileHorizontalDotsMajor,
  DeleteMinor,

} from '@shopify/polaris-icons';
import utils from '../../../../utils/utils';
import Language from '../../../../i18n/Language';
import FaqCardBox from '../../../../components/FaqCardBox';
import FooterTrustHelp from '../../../../components/FooterTrustHelp';
const t = Language;

class indexClass extends Component {

  state = {
    generating: t("Generating, please wait"),
    generatingSign: '',
    previewShow: false,// 预览页面链接显示控制
    //是否显示对应的通知
    hide_jsonld_notify: true,
    hide_struct_notify: true,
    hide_sitemap_notify: true,
    showPro: true,
    htmlSitemapUrl: "",
    addLinksArr: [],
    addLinksContent: '',//动态添加的组件
    addLinksNum: 0,
    limit_items: 0,//sitemap 限制数量
    choice: [],//sitemap 页面
    page_choices: [
      { label: t("Products"), value: "1" },
      { label: t("Collection"), value: "2" },
      { label: t("Blogs"), value: "3" },
      { label: t("Blogs Posts"), value: "4" },
      { label: t("Pages"), value: "5" },
    ],

    sitemapOn: 0,
    productOn: 0,
    collectionOn: 0,
    blogOn: 0,
    articleOn: 0,
    resultOptionSelected: 2,
    checked: false,
    banner1: true,    //第一个banner 组件
    banner2: true,    //第一个banner 组件

    business_type: 'Organization', // business type

    // 保存按钮加载状态
    firstSaveButtonLoading: false,

    localTypeOoptions: [],
    specificTypeOoptions: [],
    mon_time: {
      switch: false,
    },
    tue_time: {
      switch: false,
    },
    wed_time: {
      switch: false,
    },
    thu_time: {
      switch: false,
    },
    fri_time: {
      switch: false,
    },
    sat_time: {
      switch: false,
    },
    sun_time: {
      switch: false,
    },

    //页面动作
    loading: false,
    loadingPage: true,
    //弹窗
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误

    //logo图片1
    files: '',
    fileUpload: '',
    uploadedFiles: '',
    //图片删除按钮
    imgButton: true,
    //Store image图片2
    filesHero: '',
    fileUploadHero: '',
    uploadedFilesHero: '',
    //图片删除按钮
    imgButtonHero: true,
    isShowAllBtnLoading: true, //全局button状态
    isShowRemoveBrand: true,
    errorIndex: {},
    limitError: '',
    initBtnSave: true,
    isShowOpenState: '', // 提示打开开关

    questionList: {
      w_htmlsite: {
        title: "What is the purpose of an HTML Sitemap?",
        tag: ["An HTML Sitemap provides an overview of a website's overall structure and content, helping users quickly find the content they're interested in, thus enhancing the website's user experience and navigational performance."]
      },
      hd_htmlsite: {
        title: "How does HTML Sitemap differ from XML site map?",
        tag: ["XML Sitemap is a machine-readable file primarily used for search engine crawling and indexing website content. HTML Sitemap, on the other hand, is a webpage designed for users to browse and navigate the website."]
      },
      hc_htmlsite: {
        title: "How to create an HTML Sitemap?",
        tag: ["Turn on the switch, and SEOAnt will automatically generate it for you. No further action is required."]
      },
      ha_htmlsite: {
        title: "How to add custom links?",
        tag: ["Click on \"Add Link,\" then enter the link without the domain name, such as /page/test.html, and input the title. After saving, you can preview it."]
      },
      daf_htmlsite: {
        title: "Does HTML Sitemap affect SEO?",
        tag: ["HTML Sitemap usually does not directly impact a website's search engine ranking. However, it can help search engines crawl and index website content and improve user experience, indirectly affecting SEO."]
      },
      ih_htmlsite: {
        title: "Is HTML Sitemap suitable for all types of websites?",
        tag: ["Yes, HTML Sitemap is suitable for all types of websites, especially for websites with a lot of content and complex structures, where HTML site map is particularly important."]
      },
      dn_htmlsite: {
        title: "Does HTML Sitemap need to be updated regularly?",
        tag: ["Yes, as website content changes and updates, the HTML Sitemap also needs to be updated regularly to reflect the latest website structure and content. SEOAnt will automatically help you with scheduled updates."]
      },
    },
    loadingSwitch: false, // 开关loading
    isShowEditModal: false,
    sitemapEditMore: false,
    choiceModal: [],
    limit_items_modal: 0,
    linksUrl: "",
    linksTitle: "",
    linkModalState: false,
    delLoading: -1,
  };

  //选择关键词
  handleChoiceChange = (value) => {
    var selectChoice = this.state.selectKeyword;
    selectChoice = value;

    this.setState({
      selectKeyword: selectChoice,
    });
  };

  // shopify 自带input框 、 Chioce List 组件的更新值得方法
  handleInputChange = (value, name) => {
    if (name === "limit_items_modal") {
      if (value <= 0) {
        value = 1
      }
    } else if (name === "linksUrl") {
      value = Boolean(value) && value[0] !== '/' ? `/${value}` : value;
    } else { }
    const state = this.state;
    this.setState({
      [name]: value,
      limitError: '',
      initBtnSave: false,
    }, () => {
      if (name === 'business_type') {
        if (value === 'Local Business') {
          if (!this.state.local_business_type) {
            this.setState({ local_business_type: state.localTypeOoptions[0].value });
          }

          if (!this.state.local_specific_type) {
            if (state.specificTypeOoptions[0]) {
              this.setState({ local_specific_type: state.specificTypeOoptions[0].value });
            }
          }
        }

        if (value === 'Organization') {
          this.setState({
            local_business_type: '',
            local_specific_type: '',
          });
        }
      }
    });
  }

  // 分类关联数据联动
  handleLocalBusinessTypeInputChange = (value, name) => {
    let specificTypeOoptions = [];
    this.setState({ [name]: value }, () => {
      Object.keys(LocalBusinessTypeAndSpecialType).forEach((key) => {
        if (LocalBusinessTypeAndSpecialType[key].name === value) {
          if (LocalBusinessTypeAndSpecialType[key].children) {
            Object.keys(LocalBusinessTypeAndSpecialType[key].children).forEach((ckey) => {
              specificTypeOoptions = [...specificTypeOoptions, { label: LocalBusinessTypeAndSpecialType[key].children[ckey].name, value: LocalBusinessTypeAndSpecialType[key].children[ckey].name }];
            });
            this.setState({
              specificTypeOoptions: specificTypeOoptions,
              local_specific_type: specificTypeOoptions[0].value, // 第二个选项职位第一个值
            })
          } else {
            this.setState({
              specificTypeOoptions: [],
              local_specific_type: '', // 第二个选项置为空
            })
          }
        }
      });
    });
  }

  // 初始化分类数据
  initData = () => {
    let localTypeOoptions = [];
    let specificTypeOoptions = [];
    Object.keys(LocalBusinessTypeAndSpecialType).forEach((key) => {
      localTypeOoptions = [...localTypeOoptions, { label: LocalBusinessTypeAndSpecialType[key].name, value: LocalBusinessTypeAndSpecialType[key].name }];
    });

    this.setState({ localTypeOoptions: localTypeOoptions }, () => {
      Object.keys(LocalBusinessTypeAndSpecialType).forEach((key) => {
        if (LocalBusinessTypeAndSpecialType[key].name === this.state.local_business_type) {
          if (LocalBusinessTypeAndSpecialType[key].children) {
            Object.keys(LocalBusinessTypeAndSpecialType[key].children).forEach((ckey) => {
              specificTypeOoptions = [...specificTypeOoptions, { label: LocalBusinessTypeAndSpecialType[key].children[ckey].name, value: LocalBusinessTypeAndSpecialType[key].children[ckey].name }];
            });
            this.setState({
              specificTypeOoptions: specificTypeOoptions,
            })
          } else {
            this.setState({
              specificTypeOoptions: [],
              local_specific_type: '', // 第二个选项置为空
            })
          }
        }
      });
    });
    //显示所有的数据
    this.showAddLinkContent();
  }

  // business hours 时间input 框
  handleCheckInputChange = (value, name) => {
    let arr1 = [];
    arr1 = name.split('.')
    const state = this.state;
    this.setState({
      [arr1[0]]: { ...state[arr1[0]], [arr1[1]]: value }
    });
  }

  // business hours 开关按钮
  handleCheckChange = (name) => {
    if (name === "sitemapOn") {
      this.setState({
        [name]: !this.state.sitemapOn
      });
    } else {
      const state = this.state;
      this.setState({
        [name]: { ...state[name], switch: !state[name].switch }
      });
    }
  }

  handleChange = (checked) => {
    this.setState({ checked });
  }

  //上传图片
  updateImage = (acceptedFiles) => {
    this.setState({
      files: acceptedFiles[0],
    });

    this.setUpdateImage(1, acceptedFiles[0]);
  };

  //删除图片
  deleteImage = () => {
    this.setState({
      files: '',
      imgButton: true,
      logo: '',
    });
    this.setUpdateImage();
  }

  //设置图片
  setUpdateImage = async (type, acceptedFiles, img) => {
    var fileUpload = '';
    var uploadedFiles = '';
    var logo = "";
    if (img) {
      fileUpload = !img && <DropZone.FileUpload />;
      uploadedFiles = img && (
        <div className="addImage">
          <Thumbnail
            size="small"
            alt=''
            source={img}
          />
        </div>
      );
      this.setState({
        imgButton: false,
        fileUpload: fileUpload,
        uploadedFiles: uploadedFiles
      });
    } else if (acceptedFiles) {
      const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      const filesImg = acceptedFiles
      if (validImageTypes.indexOf(filesImg.type) >= 0) {
        fileUpload = !filesImg && <DropZone.FileUpload />;

        //开启FileReader
        var reader = new FileReader();
        reader.readAsDataURL(filesImg); //读取文件保存在result中
        reader.onload = (e) => {
          var getRes = e.target.result;//读取的结果在result中
          const params = { img: getRes, type: filesImg.type };
          reqInsertCreateCampaignImage(params).then(response => {
            if (response.code === '200') {
              uploadedFiles = filesImg && (
                <div className="addImage">
                  <Thumbnail
                    size="small"
                    alt={filesImg.name}
                    source={response.data}
                  />
                </div>
              );
              logo = response.data;
            } else {
              fileUpload = <DropZone.FileUpload />;
              uploadedFiles = '';
            }

            this.setState({
              imgButton: false,
              fileUpload: fileUpload,
              uploadedFiles: uploadedFiles,
              logo: logo,
            });
          })
        }
      } else {
        fileUpload = <DropZone.FileUpload />;
        uploadedFiles = ''
        this.setState({
          fileUpload: fileUpload,
          uploadedFiles: uploadedFiles,
          logo: logo,
        });
      }
    } else {
      fileUpload = <DropZone.FileUpload />;
      uploadedFiles = ''
      this.setState({
        fileUpload: fileUpload,
        uploadedFiles: uploadedFiles,
        logo: logo,
      });
    }
  }

  //上传图片
  updateImageHero = (acceptedFiles) => {
    this.setState({
      filesHero: acceptedFiles[0],
    });
    this.setUpdateImageHero(1, acceptedFiles[0]);
  };

  //删除图片
  deleteImageHero = () => {
    this.setState({
      filesHero: '',
      imgButtonHero: true,
      image: '',
    });
    this.setUpdateImageHero();
  }

  //设置图片
  setUpdateImageHero = async (type, acceptedFiles, img) => {
    var fileUpload = '';
    var uploadedFiles = '';
    var image = "";
    if (img) {
      fileUpload = !img && <DropZone.FileUpload />;
      uploadedFiles = img && (
        <div className="addImage">
          <Thumbnail
            size="small"
            alt=''
            source={img}
          />
        </div>
      );
      this.setState({
        imgButtonHero: false,
        fileUploadHero: fileUpload,
        uploadedFilesHero: uploadedFiles
      });
    } else if (acceptedFiles) {
      const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      const filesImg = acceptedFiles
      if (validImageTypes.indexOf(filesImg.type) >= 0) {
        fileUpload = !filesImg && <DropZone.FileUpload />;

        //开启FileReader
        var reader = new FileReader();
        reader.readAsDataURL(filesImg); //读取文件保存在result中
        reader.onload = (e) => {
          var getRes = e.target.result;//读取的结果在result中
          const params = { img: getRes, type: filesImg.type };
          reqInsertCreateCampaignImage(params).then(response => {
            if (response.code === '200') {
              uploadedFiles = filesImg && (
                <div className="addImage">
                  <Thumbnail
                    size="small"
                    alt={filesImg.name}
                    source={response.data}
                  />
                </div>
              );
              image = response.data;
            } else {
              fileUpload = <DropZone.FileUpload />;
              uploadedFiles = '';
            }

            this.setState({
              imgButtonHero: false,
              fileUploadHero: fileUpload,
              uploadedFilesHero: uploadedFiles,
              image: image,
            });
          })
        }
      } else {
        fileUpload = <DropZone.FileUpload />;
        uploadedFiles = ''
        this.setState({
          fileUploadHero: fileUpload,
          uploadedFilesHero: uploadedFiles,
          image: image,
        });
      }
    } else {
      fileUpload = <DropZone.FileUpload />;
      uploadedFiles = ''
      this.setState({
        fileUploadHero: fileUpload,
        uploadedFilesHero: uploadedFiles,
        image: image,
      });
    }
  }
  //更新sitemap数据
  updateSitemapData = (oprate, linkArray) => {
    this.setState({
      loadingSwitch: true
    }, async () => {
      const state = this.state;
      if (oprate !== 'string' && state.choiceModal.length === 0) {
        this.props.toggleToast(t("Must choose one!"), false);
      } else {
        if (!state.sitemapOn) {
          this.checkPreviewFinish()
        }
        let params = {};
        this.setState({ firstSaveButtonLoading: true });
        if (oprate === 'statusOperate') {
          params = {
            sitemapOn: state.sitemapOn ? 0 : 1,
          };
          // 深拷贝缓存数据 用于及时更新开关状态
          let _page = this.props.page;
          let htmlSitemapDeepClone = cloneDeep(_page.pageInit.htmlSitemap.getStructuredData)
          htmlSitemapDeepClone.data.HTMLSitemap.status = state.sitemapOn ? 0 : 1
          // console.log(htmlSitemapDeepClone);
          this.props.getPageDataRedux({ 'getStructuredData': htmlSitemapDeepClone })
        } else {
          //包含空项不允许保存
          var notEmptyArr = linkArray || state.addLinksArr;
          var linkHasEmpty = 0;
          let errorId = {};
          notEmptyArr.forEach(element => {
            if (element.title === '' || element.link === '') {
              linkHasEmpty = 1;
              errorId[`${element.id}`] = {};
              if (element.title === '') {
                errorId[`${element.id}`]['titleError'] = "Please enter the complete title!";
                this.setState({
                  errorIndex: errorId,
                }, () => {
                  //显示所有的数据
                  this.showAddLinkContent();
                });
              }
              if (element.link === '') {
                errorId[`${element.id}`]['urlError'] = "Please enter the complete link!";
                this.setState({
                  errorIndex: errorId,
                }, () => {
                  //显示所有的数据
                  this.showAddLinkContent();
                });
              }
            }
          });
          if (linkHasEmpty) {
            // this.props.toggleToast(t("Please enter the complete link and title!"),false);
            this.setState({
              firstSaveButtonLoading: false,
            });
            return '';
          }
          if (state.limit_items_modal > 1000) {
            // this.props.toggleToast(t("Please enter an integer less than 1000!"),false);
            this.setState({
              firstSaveButtonLoading: false,
              limitError: "Please enter an integer less than 1000!",
            });
            return '';
          }
          params = {
            choice: state.choiceModal,
            add_links: linkArray || state.addLinksArr,
            limit_items: state.limit_items_modal,
            sitemapOn: state.sitemapOn ? 1 : 0,
          };
        }
        const response = await reqUpdateHTMLSitemap(params);
        if (response.code === '200') {
          if (oprate === 'statusOperate') {
            this.setState({
              sitemapOn: !state.sitemapOn,
              previewShow: false,
            });
          }
          this.setState({
            initBtnSave: true,
            isShowEditModal: false,
            choice: state.choiceModal,
            limit_items: state.limit_items_modal,
            linkModalState: false,
            addLinksArr: linkArray || state.addLinksArr,
            isShowOpenState: false,
          })
          this.props.toggleToast(response.msg, false);
        } else {
          this.props.toggleToast(t("something wrong!"), true);
          return '';
        }
        this.setState({
          firstSaveButtonLoading: false,
          loadingSwitch: false,
          delLoading: -1,
        });
      }
    })
  }

  checkPreviewFinish = async () => {
    const response = await reqCheckPreviewFinish();
    if (response.code === 200) {
      if (response.finish) {
        setTimeout(() => {
          this.setState({
            previewShow: true,
          })
        }, 2000)
      } else {
        this.setState({
          generatingSign: this.state.generatingSign + '.'
        })
        setTimeout(this.checkPreviewFinish, 1000)
      }
      if (this.state.generatingSign.length > 3) {
        this.setState({
          generatingSign: ''
        })
      }
    }
  }

  updateStructuredData = async (type) => {
    const state = this.state;

    let params = {};
    let response = '';
    switch (type) {
      case 'company':
        this.setState({ firstSaveButtonLoading: true });
        params = {
          business_type: state.business_type,
          brand_name: state.brand_name,
          local_business_type: state.local_business_type,
          local_specific_type: state.local_specific_type,
          logo: state.logo,
          image: state.image,
          description: state.description,
          business_name: state.business_name,
          price_range: state.price_range,

          street_address: state.street_address,
          zip_code: state.zip_code,
          city: state.city,
          country: state.country,
          provence: state.provence,


          customer_phone_num: state.customer_phone_num,
          technical_phone_num: state.technical_phone_num,
          sale_phone_num: state.sale_phone_num,
          email: state.email,

          latitude: state.latitude,
          longitude: state.longitude,
          // google_map_url      : state.google_map_url,


          mon_time: state.mon_time,
          tue_time: state.tue_time,
          wed_time: state.wed_time,
          thu_time: state.thu_time,
          fri_time: state.fri_time,
          sat_time: state.sat_time,
          sun_time: state.sun_time,


          youtube_url: state.youtube_url,
          facebook_url: state.facebook_url,
          google_url: state.google_url,
          twitter_url: state.twitter_url,
          linkedin_url: state.linkedin_url,
          instagram_url: state.instagram_url,
          pinterest_url: state.pinterest_url,


        };
        response = await reqUpdateStructuredData(params)
        this.setState({ firstSaveButtonLoading: false });
        break;

      default:
        this.props.toggleToast(t("something wrong!"), true);
        return '';
    }

    if (response.code === '200') {
      this.props.toggleToast(response.msg, false);
    } else if (response.code === '1000') {
      // this.setState({UpgradeModel:true});
      this.props.show(1);
    }
    else {
      this.props.toggleToast(response.msg, true);
    }
  }

  // 获取用户设置的数据
  getStructuredData = async () => {
    let _page = this.props.page;
    if (Boolean(Object.keys(_page.pageInit['htmlSitemap']).length)) {
      this.setState({
        loading: false
      });
    } else {
      this.setState({
        loading: true
      });
    }
    const response = await reqGetHtmlSitemapData()
    // let value = '';
    if (response.code === 200) {
      // 判断是否第一次 第一次则缓存
      this.props.getPageDataRedux({ 'getStructuredData': response });
      // setTimeout(() => {
      //     console.log('htmlSitemap', this.props.public);
      // }, 1000)
      // let array = ['mon_time','tue_time','wed_time','thu_time','fri_time','sat_time','sun_time'];
      // Object.keys(response.data).forEach((key)=>{
      //   if(array.indexOf(key) >=0 ){
      //     value = JSON.parse(response.data[key])
      //     value.switch = value.switch ==='true'?true:false;
      //     this.setState({[key]: value});
      //   }else{
      //     this.setState({[key]:response.data[key]});
      //   }

      // });

      this.setState({
        // UpgradeModel:response.data.structured_data_show?false:true,
        // showPro:response.data.structured_data_show?true:false,
        // productOn:response.jsonConfig.productOn,
        // collectionOn:response.jsonConfig.collectionOn,
        // blogOn:response.jsonConfig.blogOn,
        // articleOn:response.jsonConfig.articleOn,
        sitemapOn: response.data.HTMLSitemap.status,
        previewShow: response.data.HTMLSitemap.status,
        choice: response.data.HTMLSitemap.choice_pages,
        limit_items: response.data.HTMLSitemap.limit_items,
        addLinksArr: response.data.HTMLSitemap.add_links,
        addLinksNum: response.data.HTMLSitemap.add_links.length,
        htmlSitemapUrl: response.data.htmlSitemapUrl,
        choiceModal: response.data.HTMLSitemap.choice_pages,
        limit_items_modal: response.data.HTMLSitemap.limit_items,
        // hide_struct_notify:response.data.hide_struct_notify,
        // hide_jsonld_notify:response.data.hide_jsonld_notify,
        // hide_sitemap_notify:response.data.hide_sitemap_notify
      });

      //更新logo
      // if(response.data.logo){
      //   this.setUpdateImage(0,'',response.data.logo);
      // }else{
      //   this.setUpdateImage();
      // }
      // //更新image
      // if(response.data.image){
      //   this.setUpdateImageHero(0,'',response.data.image);
      // }else{
      //   this.setUpdateImageHero();
      // }
    }
    this.setState({
      loading: false,
      loadingPage: false,
    }, () => {
      this.initData() // 执行完毕后初始化数据
    });
  }

  //隐藏通知栏
  hideNofity = async (type) => {
    const params = { type: type };
    const response = await reqUpdateHideNotify(params);
    if (response.code === '200') {
      switch (type) {
        case "jsonld":
          this.setState({
            hide_jsonld_notify: true
          });
          break;
        case "structed":
          this.setState({
            hide_struct_notify: true
          });
          break;
        case "sitemap":
          this.setState({
            hide_sitemap_notify: true
          });
          break;
        default:
          return '';
      }
    }
  }

  componentDidMount() {
    this.setSwitchState(); // 获取banner状态

    // 判断是否已经缓存到redux中 如果缓存了则使用缓存的值
    let _page = this.props.page;
    if (Boolean(Object.keys(_page.pageInit['htmlSitemap']['getStructuredData']).length)) {
      let res = _page.pageInit['htmlSitemap']['getStructuredData']

      this.setState({
        loading: false,
        loadingPage: false,
      });
      // let value = '';
      // let array = ['mon_time','tue_time','wed_time','thu_time','fri_time','sat_time','sun_time'];
      // Object.keys(res.data).forEach((key)=>{
      //   if(array.indexOf(key) >=0 ){
      //     value = JSON.parse(res.data[key])
      //     value.switch = value.switch ==='true'?true:false;
      //     this.setState({[key]: value});
      //   }else{
      //     this.setState({[key]:res.data[key]});
      //   }

      // });

      this.setState({
        // UpgradeModel:res.data.structured_data_show?false:true,
        // showPro:res.data.structured_data_show?true:false,
        // productOn:res.jsonConfig.productOn,
        // collectionOn:res.jsonConfig.collectionOn,
        // blogOn:res.jsonConfig.blogOn,
        // articleOn:res.jsonConfig.articleOn,
        sitemapOn: res.data.HTMLSitemap.status,
        previewShow: res.data.HTMLSitemap.status,
        choice: res.data.HTMLSitemap.choice_pages,
        limit_items: res.data.HTMLSitemap.limit_items,
        addLinksArr: res.data.HTMLSitemap.add_links,
        addLinksNum: res.data.HTMLSitemap.add_links.length,
        htmlSitemapUrl: res.data.htmlSitemapUrl,
        choiceModal: res.data.HTMLSitemap.choice_pages,
        limit_items_modal: res.data.HTMLSitemap.limit_items,
        // hide_struct_notify:res.hide_struct_notify,
        // hide_jsonld_notify:res.hide_jsonld_notify,
        // hide_sitemap_notify:res.hide_sitemap_notify
      });

      //更新logo
      if (res.data.logo) {
        this.setUpdateImage(0, '', res.data.logo);
      } else {
        this.setUpdateImage();
      }
      //更新image
      if (res.data.image) {
        this.setUpdateImageHero(0, '', res.data.image);
      } else {
        this.setUpdateImageHero();
      }

      this.setState({
        loading: false,
        loadingPage: false,
      }, () => {
        this.initData() // 执行完毕后初始化数据
      });
    }
    if (window.location.search !== "") {
      if (window.location.search.substring(6) === "1") {
        this.setState({
          resultOptionSelected: 1
        });
      } else if (window.location.search.substring(6) === '2') {
        this.setState({
          resultOptionSelected: 2
        });
      }
    }
    this.getStructuredData()
    this.changeHtmlSitemapDataStatus()
  }

  componentWillUnmount() {
    this.props.setResetBtnLoading('htmlSitemap'); // 重置全局数据更新状态
    this.setState = () => false
  }

  setSwitchState = () => {
    let switchData = this.props.public.publicInit.head_data?.switch_data;
    this.setState({
      isShowRemoveBrand: typeof switchData === 'boolean' ? true : !Boolean(switchData?.html_removebrand),
    })
  }

  // 获取缓存数据更新状态
  changeHtmlSitemapDataStatus = () => {
    let setData = this.props.page.pageInit.htmlSitemap;
    if (setData.isResetLoading) {
      this.setState({
        isShowAllBtnLoading: false
      })
    } else {
      setTimeout(() => {
        this.changeHtmlSitemapDataStatus();
      }, 1000)
    }
  }

  // 优化结果类型 切换
  handleResultTabsChange = (selectedTabIndex) => {
    this.setState({
      resultOptionSelected: selectedTabIndex,
    });
  };

  //修改用户jsonLD配置
  updateStructedConfig = async (type) => {
    const state = this.state;
    let params = {};
    let response = '';
    switch (type) {
      case 'productOn':
        params = {
          productOn: state.productOn ? 0 : 1,
        };
        response = await reqUpdateJsonLDConfig(params);
        if (response.code === '200') {
          this.setState({ productOn: !state.productOn });
          this.props.toggleToast(response.msg, false);
        }
        break;
      case 'collectionOn':
        params = {
          collectionOn: state.collectionOn ? 0 : 1
        };
        response = await reqUpdateJsonLDConfig(params);
        if (response.code === '200') {
          this.setState({ collectionOn: !state.collectionOn });
          this.props.toggleToast(response.msg, false);
        }
        break;
      case 'blogOn':
        params = {
          blogOn: state.blogOn ? 0 : 1
        };
        response = await reqUpdateJsonLDConfig(params);
        if (response.code === '200') {
          this.setState({ blogOn: !state.blogOn });
          this.props.toggleToast(response.msg, false);
        }
        break;
      case 'articleOn':
        params = {
          articleOn: state.articleOn ? 0 : 1
        };
        response = await reqUpdateJsonLDConfig(params);
        if (response.code === '200') {
          this.setState({ articleOn: !state.articleOn });
          this.props.toggleToast(response.msg, false);
        }
        break;
      default:
        this.props.toggleToast(t("something wrong!"), true);
        return '';
    }
  }

  //动态添加组件
  addLinksComponent = () => {
    if (this.state.sitemapOn) {
      this.setState({
        linkModalState: true,
      })
      // // 可控制数量
      // var arrLinks = cloneDeep(this.state.addLinksArr);

      // // for (let index = 0; index < arrLinks.length; index++) {
      // //   if(arrLinks[index].link==='' || arrLinks[index].title===''){
      // //     this.props.toggleToast(t("Please enter the complete link and title!"),false);
      // //     return '';
      // //   }
      // // }
      // //包含空项不允许保存
      // var linkHasEmpty = 0;
      // let errorId = {};
      // arrLinks.forEach(element => {
      //   if (element.title === '' || element.link === '') {
      //     linkHasEmpty = 1;
      //     errorId[`${element.id}`] = {};
      //     if (element.title === '') {
      //       errorId[`${element.id}`]['titleError'] = "Please enter the complete title!";
      //       this.setState({
      //         errorIndex: errorId,
      //       }, () => {
      //         //显示所有的数据
      //         this.showAddLinkContent();
      //       });
      //     }
      //     if (element.link === '') {
      //       errorId[`${element.id}`]['urlError'] = "Please enter the complete link!";
      //       this.setState({
      //         errorIndex: errorId,
      //       }, () => {
      //         //显示所有的数据
      //         this.showAddLinkContent();
      //       });
      //     }
      //   }
      // });
      // if (linkHasEmpty) {
      //   return '';
      // }

      // var id = parseInt(this.state.addLinksNum) + 1;
      // var newLinks = { 'id': id, 'link': '', 'title': '' };
      // arrLinks.push(newLinks);
      // this.setState({
      //   addLinksArr: arrLinks,
      //   addLinksNum: id + "",
      //   initBtnSave: false,
      // }, () => {
      //   this.showAddLinkContent();
      // })
    } else {
      this.setState({
        isShowOpenState: "Please open Sitemap state!",
      })
      // this.props.toggleToast(t("Please open Sitemap state!"),false);
    }
  }
  //删除组件
  deleteAddLinkComponent = (ID) => {
    var remain = [];
    remain = this.state.addLinksArr.filter((item, key) => {
      return item.id !== ID;
    });
    this.setState({
      addLinksArr: remain,
      initBtnSave: false,
    }, () => {
      this.showAddLinkContent();
    })
  }
  //修改组件内容
  changeAddLinkComponent = (result) => {
    var newarr = [];
    let data = cloneDeep(this.state.errorIndex);
    this.state.addLinksArr.forEach((item, key) => {
      if (item.id === result.id) {
        if (Object.keys(data).filter(i => Number(i) === Number(result.id)).length > 0) {
          if (result.link !== '') {
            data[`${result.id}`]['urlError'] = '';
          }
          if (result.title !== '') {
            data[`${result.id}`]['titleError'] = '';
          }
        }
        newarr[key] = result;
      } else {
        newarr[key] = item;
      }
    });
    this.setState({
      addLinksArr: newarr,
      errorIndex: data,
    }, () => {
      this.showAddLinkContent();
    })
  }

  //动态显示Addlink组件
  showAddLinkContent = () => {
    var addlinks = this.state.addLinksArr.map((item, index) => {
      return (
        <AddLinks
          key={index}
          componentID={item.id}
          link={item.link}
          title={item.title}
          deleteComponent={this.deleteAddLinkComponent}
          changeComponent={this.changeAddLinkComponent}
          errorIndex={this.state.errorIndex}
        />
      )
    });
    this.setState({
      addLinksContent: addlinks
    });
  }

  htmlSitemapUrl = () => {
    window.open("https://" + this.state.htmlSitemapUrl)
  }

  //点击联系客服
  handleContactService = async (content) => {
    // window.Intercom('showNewMessage', content);
    // window.$crisp.push(["set", "message:text", [content]])
    // window.$crisp.push(["do", "chat:open"])
    try {
      window.Willdesk.chat(content)
    } catch (e) {
      this.props.toggleToast(t("Try again later"), true)
    }
    const params = {
      'path': window.location.pathname,
      'content': content
    };
    await reqUpdateCustomerClick(params);
  }

  // 关闭banner
  closeBannerObj = (type, obj) => {
    this.setState({
      [obj]: false,
    }, () => {
      this.requestStateSet(type);
    })
  }

  // 发送请求
  requestStateSet = async (type) => {
    const params = {
      name: `${type}`,
      st: 0,
      exp: 0,
      type: `param`
    }
    const res = await reqSaveSwitchState(params);
    if (res.ack === 1) {
      let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
      if (typeof data === 'boolean') {
        data = [];
      }
      data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 0, "exp": 0 };
      this.props.setSwitchData(data);
    } else {
      this.props.toggleToast(t("Try again later"), true)
    }
  }

  // 返回
  goBack = () => {
    utils.routeJump(this, '/backlinks')
  }

  // 关闭编辑弹窗
  closeSMEditModal = () => {
    this.setState({
      isShowEditModal: false,
    })
  }

  // 打开关闭
  toggleSitemapMore = () => {
    this.setState({
      sitemapEditMore: !this.state.sitemapEditMore,
    })
  }

  // 打开编辑
  openSitemapEditModal = () => {
    if (!this.state.sitemapOn) {
      this.setState({
        isShowOpenState: "Please open Sitemap state!",
        sitemapEditMore: false,
      })
    } else {
      this.setState({
        isShowEditModal: true,
        sitemapEditMore: false,
      })
    }
  }

  // 关闭
  closeLinksEditModal = () => {
    this.setState({
      linkModalState: false,
    })
  }

  // 添加链接
  saveAddLinksArray = () => {
    let { linksUrl, linksTitle, addLinksArr } = this.state;
    let newArr = cloneDeep(addLinksArr);
    newArr.push({
      title: linksTitle,
      link: linksUrl
    })
    this.updateSitemapData(null, newArr);
  }

  // 删除链接
  deleteLinkObj = (index) => {
    let { addLinksArr } = this.state;
    let newArr = cloneDeep(addLinksArr);
    newArr.splice(index, 1);
    this.setState({
      delLoading: index
    }, () => {
      this.updateSitemapData(null, newArr);
    })
  }

  render() {
    const {
      isShowRemoveBrand,
      choice,
      limitError,
      isShowOpenState,
      questionList,
      loadingSwitch,
      sitemapOn,
      isShowEditModal,
      sitemapEditMore,
      choiceModal,
      limit_items_modal,
      linksUrl,
      linksTitle,
      linkModalState,
      addLinksArr,
      delLoading,

    } = this.state;

    // 编辑弹窗
    const SitemapEditModal = <Modal
      open={isShowEditModal}
      title={t("Edit html sitemap page settings")}
      primaryAction={{
        content: t("Save"),
        disabled: !sitemapOn || (choice.length === 0) || this.state.initBtnSave,
        loading: this.state.firstSaveButtonLoading || this.state.isShowAllBtnLoading,
        onAction: this.updateSitemapData
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: this.closeSMEditModal,
        }
      ]}
      onClose={this.closeSMEditModal}
    >
      <Modal.Section>
        <FormLayout>
          <FormLayout.Group>
            <ChoiceList
              allowMultiple
              title={t("Build HTML Sitemap for")}
              choices={this.state.page_choices}
              selected={choiceModal}
              id="choiceModal"
              name="choiceModal"
              onChange={this.handleInputChange}
            />
            {
              choiceModal.length === 0 && <Text as="p" tone="critical">
                <span className='flex_layout error_tip_html'>
                  <Icon source={DiamondAlertMinor} tone="critical" />
                  {t("Choose at least one.")}
                </span>
              </Text>
            }
          </FormLayout.Group>
          <FormLayout.Group>
            <div style={{ width: "40%" }}>
              <TextField
                label={t("Limit items to be shown")}
                id="limit_items_modal"
                value={limit_items_modal}
                onChange={this.handleInputChange}
                type="number"
                max={1000}
                error={limitError}
              />
            </div>
          </FormLayout.Group>
        </FormLayout>
      </Modal.Section>
    </Modal >

    // 添加链接弹窗
    const addLinksModal = <Modal
      open={linkModalState}
      title={t("Add links")}
      primaryAction={{
        content: t("Save"),
        onAction: this.saveAddLinksArray,
        disabled: !linksUrl || !linksTitle,
        loading: loadingSwitch,
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: this.closeLinksEditModal,
        }
      ]}
      onClose={this.closeLinksEditModal}
    >
      <Modal.Section>
        <TextField
          id="linksUrl"
          label={t("URL")}
          value={linksUrl}
          onChange={this.handleInputChange}
          placeholder='/pages/test.html'
        />
        <TextField
          id="linksTitle"
          label={t("Title")}
          value={linksTitle}
          onChange={this.handleInputChange}
          placeholder={t("your page title")}
        />
      </Modal.Section>
    </Modal>

    const loadingMarkup = this.state.loading ? <div className="DetailReport_Empty_New_div_margin_800">
      <Spinner size="large" color="teal" />
    </div> : '';
    // const test = this.state.generating + this.state.generatingSign;
    // const previewUrl = this.state.previewShow ? null : sitemapOn ? test : '';
    //打开才有保存
    // const SitemapStateSaveData =
    //   <BlockStack inlineAlign="end">
    //     {""}
    //     {previewUrl}
    //     <Button variant="primary" disabled={!sitemapOn || (choice.length === 0) || this.state.initBtnSave} loading={this.state.firstSaveButtonLoading || this.state.isShowAllBtnLoading} onClick={this.updateSitemapData} >{t("Save")}</Button>
    //   </BlockStack>

    // const addLinks = <div>
    //   <div className="halfspace"></div>
    //   <Button loading={this.state.isShowAllBtnLoading} variant='primary' onClick={() => this.addLinksComponent()}>
    //     {t("+Add Links")}
    //   </Button>
    // </div>;
    // const choice_content = 1 ?
    //   <div className="inlineBlockLi">
    //     <FormLayout>
    //       <FormLayout.Group>
    //         <div className="inlineBlockLiTag">
    //           <ChoiceList
    //             allowMultiple
    //             title={t("Build HTML Sitemap for")}
    //             choices={this.state.page_choices}
    //             selected={this.state.choice}
    //             id="choice"
    //             name="choice"
    //             onChange={this.handleInputChange}
    //           />
    //           {
    //             this.state.choice.length === 0 && <Text as="p" tone="critical">
    //               <span className='flex_layout error_tip_html'>
    //                 <Icon source={DiamondAlertMinor} tone="critical" />
    //                 {t("Choose at least one.")}
    //               </span>
    //             </Text>
    //           }
    //         </div>
    //       </FormLayout.Group>
    //       <FormLayout.Group>
    //         <div style={{ width: "40%" }}>
    //           <TextField
    //             label={t("Limit items to be shown")}
    //             id="limit_items"
    //             value={this.state.limit_items + ""}
    //             onChange={this.handleInputChange}
    //             type="number"
    //             max={1000}
    //             error={limitError}
    //           />
    //         </div>
    //         {""}
    //       </FormLayout.Group>
    //     </FormLayout>
    //     <FormLayout>
    //       {addLinks}
    //       <div className="addLinksDiv">
    //         {this.state.addLinksContent}
    //       </div>
    //     </FormLayout>

    //     <FormLayout>
    //       {SitemapStateSaveData}
    //     </FormLayout>
    //   </div>

    //   : null;

    const html_content = this.state.loadingPage ? <SkeltonLoading /> : this.state.resultOptionSelected === 2 ?
      <div className='html_content_box'>
        <Layout>
          <Layout.Section>
            {
              false &&
              <div>
                <Banner title={t("What is HTML Sitemap?")} onDismiss={() => { this.hideNofity("sitemap") }}>
                  <p>
                    {t("Sitemap is a list of pages of a website. Search engines like Google read this file as a directory to crawl your site. A sitemap tells Google which pages and files you think are important in your site.")}
                  </p>
                </Banner>
                <div className="halfspace"></div>
              </div>
            }
          </Layout.Section>
        </Layout>

        <Card>
          {
            Boolean(isShowOpenState) && <div style={{ marginBottom: '1rem' }}>
              <Banner
                title={t(isShowOpenState)}
                tone='warning'
                onDismiss={() => {
                  this.setState({ isShowOpenState: '' })
                }}
              >
              </Banner>
            </div>
          }
          <div className='flex_layout'>
            <Text variant="headingMd" as="h2">{t("Show HTML sitemap page")}</Text>
            <span style={{ marginRight: 'auto' }}><Badge tone={sitemapOn ? "success" : ""}>{sitemapOn ? t("On") : t("Off")}</Badge></span>
            {(loadingSwitch || this.state.isShowAllBtnLoading) && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem' }} alt="loading" />}
            <Switch disabled={choice.length === 0 || loadingSwitch || this.state.isShowAllBtnLoading} onChange={() => this.updateSitemapData('statusOperate')} checked={Boolean(sitemapOn)} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
          </div>
          <p style={{ color: "#767676" }}>{t("Activate this feature. SEOAnt will build a HTML")}{
              sitemapOn ? <span className='jump_text' onClick={this.htmlSitemapUrl}>&nbsp;{t("sitemap page")}&nbsp;</span> : <span>&nbsp;{t("sitemap page")}&nbsp;</span>
            }{t("for your website.")}</p>
          {/* {choice_content} */}
          <div className='setting_result'>
            <div className='sitemap_page'>
              <div className='build_tag'>
                <p className='Every_Card_Text'>{t("Build HTML Sitemap for")}</p>
                <span className="build_badge">
                  {this.state.choice.includes('1') && <Badge>{t("Products")}</Badge>}
                  {this.state.choice.includes('2') && <Badge>{t("Collection")}</Badge>}
                  {this.state.choice.includes('3') && <Badge>{t("Blogs")}</Badge>}
                  {this.state.choice.includes('4') && <Badge>{t("Blogs Posts")}</Badge>}
                  {this.state.choice.includes('5') && <Badge>{t("Pages")}</Badge>}
                </span>
              </div>
              <div className='limit_items'>
                <p className='Every_Card_Text'>{t("Limit items to be shown")}</p>
                <span>{this.state.limit_items}</span>
              </div>
              <div className='sitemap-more'>
                <Popover
                  active={sitemapEditMore}
                  activator={
                    <span className='meta-more' onClick={() => this.toggleSitemapMore()}><Icon source={MobileHorizontalDotsMajor} tone='base' /></span>
                  }
                  onClose={() => this.toggleSitemapMore()}
                >
                  <ActionList
                    actionRole="menuitem"
                    items={[
                      {
                        content: t("Edit"),
                        onAction: () => this.openSitemapEditModal(),
                      },
                    ]}
                  />
                </Popover>
              </div>
            </div>
            <div className='add_other_links'>
              <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                <p className='Every_Card_Text'>{t("Other links")}</p>
                <Button disabled={this.state.isShowAllBtnLoading} icon={CirclePlusMajor} variant='plain' onClick={() => this.addLinksComponent()}>{t("Add links")}</Button>
              </div>
              <div className='all_other_links' style={{ display: addLinksArr.length > 0 ? 'flex' : 'none' }}>
                {
                  addLinksArr.map((item, index) => {
                    return <div key={`${index}-${item.title}`} className='flex_layout'>
                      <p className='link-obj'>
                        <Tooltip content={item.link}>
                          <span>{item.title}</span>
                        </Tooltip>
                      </p>
                      <Button icon={DeleteMinor} disabled={this.state.isShowAllBtnLoading} loading={delLoading === index} onClick={() => this.deleteLinkObj(index)}></Button>
                    </div>
                  })
                }
              </div>
            </div>
          </div>
        </Card>
        {loadingMarkup}
      </div>
      : null;

    const htmlSitemapServe = this.state.loadingPage ? null : sitemapOn && isShowRemoveBrand ? <div className='HTMLSitemapBanner'>
      <Banner
        title={"😘 " + t("Remove SEOAnt branding for Free")}
        tone="info"
        onDismiss={() => this.closeBannerObj(SwitchAll['html_rb'], 'isShowRemoveBrand')}
      >
        <p>{t("Contact support to remove the branding (worth $29/month) from your html sitemap page.")}</p>
        <div className='Polaris-Banner-PrimaryAction'>
          <p>
            <Button onClick={() => this.handleContactService("I want to remove SEOAnt Branding On Html Sitemap Page for free")}>{t("Contact us")}</Button>

            {/* {!this.state.isShowAllBtnLoading ? <span className='HTMLSitemapBannerRemoveText' onClick={this.htmlSitemapUrl}>{t("Preview")} </span> : null} */}
          </p>
        </div>
      </Banner>
    </div> : null;

    const HTMLSitemapBanner = this.state.loadingPage ? <SkeltonLoading /> : htmlSitemapServe;

    // FAQ
    const FrequentlyItems = <FaqCardBox FaqList={questionList} />

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终内容
    var pageContentLast = this.state.loadingPage ? <SkeltonLoading /> :
      <Page
      // title={<div style={{ display: "flex", alignItems: "center"}}>
      //   {t("HTML Sitemap")}&nbsp;
      //   <Tooltip content={t("An HTML sitemap includes the most important pages on your website for faster indexing. Control which pages to index or noindex with one single click.")}>
      //     {<Icon backdrop source={QuestionMarkInverseMajor} />}
      //   </Tooltip>
      // </div>}
      // primaryAction={{
      //   content: t("View Sitemap"),
      //   disabled: !sitemapOn,
      //   onAction: this.htmlSitemapUrl
      // }}
      // backAction={{
      //   content: t("HTML Sitemap"), 
      //   onAction: this.goBack,
      // }}
      >

        <title>SEOAnt - HTML Sitemap</title>
        <div className='pageButton flex_layout'>
          <Button variant='primary' disabled={!sitemapOn} onClick={this.htmlSitemapUrl}>{t("View Sitemap")}</Button>
        </div>
        {HTMLSitemapBanner}
        <BlockStack gap={400}>
          {html_content}
          {FrequentlyItems}
        </BlockStack>
        {SitemapEditModal}
        {addLinksModal}
        {/* 底部 */}
        {FooterHelpBox}
      </Page>

    return (
      <div id='HTML-Sitemap'>
        {pageContentLast}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => ({
  // 判断是否页面第一次loading
  getPageDataRedux(data) {
    dispatch(setPageData(['htmlSitemap', data]));
  },

  // 未更新最新数据loading
  setResetBtnLoading(page) {
    dispatch(setPageLoading([page]))
  },

  // 设置自定义缓存
  setSwitchData(data) {
    dispatch(setSaveSwitchData(data))
  }
})

indexClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);